import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Star } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
const Review = () => {
  const [email, setEmail] = useState("");
  const [utilityRating, setUtilityRating] = useState("");
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    toast
  } = useToast();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !utilityRating) {
      toast({
        title: "Errore",
        description: "Per favore compila tutti i campi obbligatori.",
        variant: "destructive"
      });
      return;
    }
    setIsSubmitting(true);
    try {
      const {
        error
      } = await supabase.from("reviews").insert({
        email,
        utility_rating: parseInt(utilityRating),
        comment: comment || null
      });
      if (error) throw error;
      toast({
        title: "Grazie!",
        description: "La tua recensione è stata inviata con successo."
      });

      // Reset form
      setEmail("");
      setUtilityRating("");
      setComment("");
    } catch (error) {
      console.error("Error submitting review:", error);
      toast({
        title: "Errore",
        description: "Si è verificato un errore durante l'invio. Riprova più tardi.",
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-background">
      <Navbar />
      
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto">
          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle className="text-3xl font-bold text-center text-primary">
                Condividi la tua Opinione
              </CardTitle>
              <p className="text-center text-muted-foreground mt-2">
                La tua opinione è importante per noi. Aiutaci a migliorare Vertigo con il tuo feedback.
              </p>
            </CardHeader>
            
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Email Input */}
                <div className="space-y-2">
                  <Label htmlFor="email">Email *</Label>
                  <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="inserisci la tua email" required />
                </div>

                {/* Utility Rating */}
                <div className="space-y-4">
                  <div>
                    <Label className="text-base font-semibold">Utilità percepita *</Label>
                    <p className="text-sm text-muted-foreground mt-1">
                      Quanto ritieni necessaria una soluzione come Vertigo, per creare processi di assunzione inclusivi ed efficienti?
                    </p>
                  </div>
                  
                  <RadioGroup value={utilityRating} onValueChange={setUtilityRating}>
                    <div className="flex justify-between items-center">
                      {[1, 2, 3, 4, 5].map(rating => <div key={rating} className="flex flex-col items-center space-y-2">
                          <div className="flex items-center space-x-2">
                            <RadioGroupItem value={rating.toString()} id={`rating-${rating}`} />
                            <Label htmlFor={`rating-${rating}`} className="cursor-pointer">
                              <Star className={`h-6 w-6 ${parseInt(utilityRating) >= rating ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`} />
                            </Label>
                          </div>
                          <span className="text-xs text-muted-foreground">{rating}</span>
                        </div>)}
                    </div>
                  </RadioGroup>
                </div>

                {/* Comment Section */}
                <div className="space-y-3">
                  <div>
                    <p className="text-sm text-muted-foreground">
                      Il test effettuato è una versione estremamente semplificata di Vertigo, lascia di seguito un commento con funzionalità che riterresti utili, o semplicemente con la tua impressione!
                    </p>
                  </div>
                  
                  <Textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Scrivi qui il tuo commento..." rows={6} className="resize-none" />
                </div>

                {/* Submit Button */}
                <Button type="submit" disabled={isSubmitting} className="w-full text-base text-neutral-50 bg-purple-600 hover:bg-purple-500">
                  {isSubmitting ? "Invio in corso..." : "Invia Recensione"}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>;
};
export default Review;